module.exports = __webpack_public_path__ + "static/media/SnowballNFTRollingBlue.99cdedcd.gif";